import { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Tooltip,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { ISingleOwnershipChangeApplication } from 'src/Types/module/applications/applications';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';
import { url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import { IResponse } from 'src/basic-rest/types';
import { HttpClient } from 'src/Helpers/http/http';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  ICompanyOwners,
  ICompanyOwnersResponse,
} from 'src/Types/module/member/CompanyInformation';
type IProps = {
  application: ISingleOwnershipChangeApplication;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setApplication: React.Dispatch<
    React.SetStateAction<ISingleOwnershipChangeApplication>
  >;
};

const UpdateOwnerShipChangeApp = ({
  application,
  setShowModal,
  setApplication,
}: IProps) => {
  const Toast = Toaster();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors, touchedFields },
    watch,
    getValues,
    reset,
  } = useForm<any>({
    defaultValues: {},
  });

  const [ownersInfo, setOwnersInfo] = useState<ICompanyOwners[]>([]);
  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const data: ICompanyOwnersResponse = await HttpClient.get(
          `/api/atab/admin/member-company/member/owner/${application?.user_member_id}`
        );
        if (data.success) {
          setOwnersInfo(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [application.user_member_id]);
  const isStatusReject = watch('ownership_change_application_status');
  useEffect(() => {
    reset({
      ...application,
    });
  }, [application]);
  const [loading, setLoading] = useState(false);
  const onSubmit = async (value: any) => {
    const formData = new FormData();

    const touchedValues = Object?.keys(touchedFields)?.reduce(
      (acc, key) => {
        acc[key] = getValues(key);
        return acc;
      },
      {} as Record<string, any>
    );
    if (Object?.keys(touchedValues)?.length) {
      Object?.keys(touchedValues)?.forEach((key) => {
        if (
          touchedValues[key] instanceof FileList ||
          Array.isArray(touchedValues[key])
        ) {
          const file = touchedValues[key][0];
          if (file) {
            formData.append(key, file);
          }
        } else {
          formData.append(key, touchedValues[key]);
        }
      });

      try {
        const res: IResponse = await HttpClient.patch(
          `${url}/api/member/owner-change-application/${application.ownership_change_application_id}`,
          formData
        );

        if (res.success) {
          Toaster().fire({
            icon: 'success',
            title: res.message,
          });
          const data = await axios?.get(
            `${url}/api/member/owner-change-application/${id}`
          );

          if (data.data.success) {
            setApplication(data.data.data);
          }
          setShowModal(false);
          reset({});
        }
      } catch (err: any) {
        Toaster().fire({
          icon: 'error',
          title: err?.response?.data.message,
        });
      }
    } else {
      Toast.fire({
        icon: 'error',
        title: `Change field first`,
      });
    }
  };

  return (
    <>
      <Box component='form' onSubmit={handleSubmit(onSubmit)} p={0}>
        <Grid container spacing={2} mb={2}>
          <Grid xs={12} md={4} lg={4} item>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-required-label'>
                Select a previous company owner{' '}
                <span style={{ color: 'red' }}>*</span>
              </InputLabel>
              <Select
                labelId='demo-simple-select-required-label'
                id='demo-simple-select-required'
                required
                label='Select a previous company owner *'
                defaultValue={
                  application.ownership_change_application_prev_owner
                }
                {...register('ownership_change_application_prev_owner')}
              >
                {ownersInfo?.length === 0 && (
                  <MenuItem disabled>Not found</MenuItem>
                )}
                {ownersInfo?.map((company: ICompanyOwners) => (
                  <MenuItem value={company?.company_owner_id}>
                    {company?.company_owner_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Divider sx={{ m: 2, width: '98%' }}>
            PRESENT OWNER INFORMATION
          </Divider>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='New company owner name'
              required
              id='outlined-required'
              type='text'
              {...register('company_owner_name')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Company owner NID'
              id='outlined-required'
              type='text'
              {...register('company_owner_nid')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Company owner phone'
              id='outlined-required'
              type='text'
              {...register('company_owner_phone')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Company owner email'
              id='outlined-required'
              type='email'
              {...register('company_owner_email')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Company owner designation'
              id='outlined-required'
              type='text'
              {...register('company_owner_designation')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Company owner address'
              id='outlined-required'
              type='text'
              {...register('company_owner_address')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Company owner photo ( max size 5mb )'
              fieldName={`company_owner_photo`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.company_owner_photo]}
            />
          </Grid>

          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Company owner NID file ( max size 5mb )'
              fieldName={`company_owner_nid_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.company_owner_nid_file]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Company owner bio-data ( max size 5mb )'
              fieldName={`company_owner_biodata`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.company_owner_biodata]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Company owner passport ( max size 5mb )'
              fieldName={`company_owner_passport`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.company_owner_passport]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Company owner signature ( max size 5mb )'
              fieldName={`company_owner_signature`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.company_owner_signature]}
            />
          </Grid>
          <Divider sx={{ m: 2, width: '98%' }}>Company owner document</Divider>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Mocat Approval Letter ( max size 5mb )'
              fieldName={`ownership_change_application_mocat_approval_copy_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.ownership_change_application_mocat_approval_copy_file,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Mocat certificate english file ( max size 5mb )'
              fieldName={`ownership_change_application_mocat_certificate_english_copy`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.ownership_change_application_mocat_certificate_english_copy,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Trade license ( max size 5mb )'
              fieldName={`ownership_change_application_trade_license`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.ownership_change_application_trade_license,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label={
                <Tooltip title='Proof of Submission of Tax Return (Acknowledgement Receipts) (max size 5mb)'>
                  <span style={{ cursor: 'pointer' }}>
                    Proof of Submission of Tax Return (Acknowledgement Receipts)
                    (max size 5mb)
                  </span>
                </Tooltip>
              }
              fieldName={`ownership_change_application_tax_certificate`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.ownership_change_application_tax_certificate,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Change deed ( max size 5mb )'
              fieldName={`ownership_change_application_ownership_change_deed`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.ownership_change_application_ownership_change_deed,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Forwarding letter ( max size 5mb )'
              fieldName={`ownership_change_application_forwarding_letter`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.ownership_change_application_forwarding_letter,
              ]}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='demo-simple-select-label'>
                Select Status
              </InputLabel>
              <Select
                {...register('ownership_change_application_status')}
                labelId='demo-simple-select-label'
                label='Ownership status'
                defaultValue={application?.ownership_change_application_status}
              >
                <MenuItem value='pending'>Pending</MenuItem>
                <MenuItem value='approved'>Approved</MenuItem>
                <MenuItem value='rejected'>Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {(isStatusReject === 'rejected' ||
            (application?.ownership_change_application_rejected_reason &&
              application.ownership_change_application_status ===
                'rejected')) && (
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  placeholder='Write reason....'
                  id='outlined-basic'
                  label='Note'
                  variant='outlined'
                  {...register('ownership_change_application_rejected_reason')}
                  multiline
                  type='text'
                  rows={3}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>

        <Box mt={5}>
          {!loading ? (
            <Button
              type='submit'
              fullWidth
              variant='contained'
              disableElevation
            >
              Submit
            </Button>
          ) : (
            <LoadingButton
              loading
              loadingIndicator='Loading...'
              variant='contained'
              fullWidth
              disabled
            >
              <span>Loading...</span>
            </LoadingButton>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UpdateOwnerShipChangeApp;
